import VXEStore from './store'

const commands = new VXEStore()

export default commands
